{
  "legalConfirmLabel": "關閉",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "隱私權原則",
  "legalTermsOfUse": "使用條款",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_tw",
  "profileLegalNoticesMenuItem": "法律注意事項"
}
